import service from "./service"

const requestConsumerReportCode = async (payload) => {
    return service(payload)
}

export default requestConsumerReportCode
